





import {Component, Prop, Watch, Vue} from 'vue-property-decorator';

@Component({
  name: 'wishlist-badge'
})

export default class extends Vue {
  private get wishlistCount(): number {
    return this.$store.getters['CustomerWishlist/wishlistCount'];
  }
}
